export const en = {
    app_loading:             "Loading...",
    app_sign_in_tab:         "Sign in",
    app_sign_up_tab:         "Sign up",

    sign_in_email:           "Email",
    sign_in_password:        "Password",
    sign_in_submit:          "Sign in",
    sign_in_submitting:      "Signing in...",

    sign_up_full_name:       "Full name",
    sign_up_email:           "Email",
    sign_up_password:        "Password",
    sign_up_submit:          "Create account",
    sign_up_submitting:      "Creating account...",

    dashboard_title:         "Projects",
    dashboard_empty:         "No projects yet. Create one from the account menu.",
    dashboard_open_project:  "Open as new project",

    code_pane_changes:       "Changes",
    code_pane_diff:          "Diff",
    code_pane_explorer:      "Explorer",
    code_pane_editor:        "Editor",
    code_edit_mode_on:       "Enable edit mode",
    code_edit_mode_off:      "Disable edit mode",
    code_no_files:           "No files open",
    code_file_deleted:       "This file was deleted",
    code_collapse_tree:      "Collapse tree",
    code_more_actions:       "More actions",
    code_find:               "Find",

    nav_code:                "Code",
    nav_review:              "Review",
    nav_deploy:              "Deploy",
    nav_agent:               "Agent",

    deploy_title:            "Deploy",
    deploy_empty:            "No deployments configured",
    deploy_btn_frontend:     "Deploy Frontend",
    deploy_btn_backend:      "Deploy Backend",
    deploy_running:          "Deploying…",
    deploy_logs_title:       "Logs",
    deploy_logs_clear:       "Clear",
    deploy_custom_placeholder: "Service name…",
    deploy_btn_custom:       "Deploy",
    deploy_stop:             "Stop",

    account_menu_label:      "Account menu",
    account_no_projects:     "No projects",
    account_new_project:     "+ New project",
    account_close_project:   "Close project",
    account_settings:        "Settings",
    account_setup_agent:     "Setup agent",
    account_sign_out:        "Sign out",

    setup_agent_title:          "Setup Agent",
    setup_agent_install_title:  "1. Install",
    setup_agent_install_cmd:    "pip install mrgr-agent",
    setup_agent_run_title:      "2. Run",
    setup_agent_run_desc:       "Start the agent pointing at your sandbox directory. It can contain multiple projects and the agent will never access anything outside of it:",
    setup_agent_token_label:    "Your auth token",
    setup_agent_env_block:      "export MRGR_TOKEN={token}\nexport MRGR_API_URL={apiUrl}\nexport MRGR_ROOT_FOLDER=/path/to/sandbox\n\nmrgr-agent",
    setup_agent_close:          "Close",

    settings_title:          "Settings",
    settings_tab_appearance: "Appearance",
    settings_tab_claude:     "Claude",
    settings_tab_tabs:       "Tabs",
    settings_tab_ssh_keys:   "Keys",
    settings_theme:          "Theme",
    settings_language:       "Language",
    settings_max_open_tabs_desktop: "Max open tabs (desktop)",
    settings_max_open_tabs_mobile:  "Max open tabs (mobile)",
    settings_claude_model:         "Model",
    settings_claude_model_default: "Default",
    settings_claude_effort:        "Effort",
    settings_claude_effort_default: "Default",
    settings_claude_effort_low:    "Low",
    settings_claude_effort_medium: "Medium",
    settings_claude_effort_high:   "High",
    settings_claude_effort_max:    "Max",
    settings_cancel:         "Cancel",
    settings_save:           "Save",

    new_project_title:       "New project",
    new_project_placeholder: "Project name",
    new_project_cancel:      "Cancel",
    new_project_create:      "Create",

    agent_placeholder:       "Describe a task...",
    agent_send:              "Send",
    agent_stop:              "Stop",
    agent_thinking:          "Thinking…",
    agent_working:           "Working…",
    agent_approve:           "Approve",
    agent_approve_always:    "Always approve",
    agent_deny:              "Deny",
    agent_permission_responded: "Responded",
    agent_new_session:          "New session",
    agent_close_session:        "Close session",
    agent_close_session_confirm: "Close this session?",
    agent_session_settings:     "Session settings",
    agent_context_toggle:        "Toggle file context",
    agent_context_remove:        "Remove file context",
    agent_readonly_toggle:       "Toggle readonly mode (don't edit code)",
    agent_backend:               "Backend",
    agent_backend_json:          "JSON",
    agent_backend_vscode:        "VS Code",

    file_open_dir:           "Open directory",
    file_empty:              "Empty",
    file_empty_dir:          "Empty directory",
    file_delete_title:       "Delete",
    file_delete_confirm:     "Permanently delete \"{path}\" from disk? This cannot be undone.",
    file_delete_btn:         "Delete",
    file_add_to_context:     "Add to context",
    file_create_folder_title: "Create Folder",
    file_create_folder_placeholder: "Folder name",
    file_create_folder_btn:  "Create",
    file_create_file_title:  "Create File",
    file_create_file_placeholder: "File name",
    file_create_file_btn:    "Create",
    file_rename_title:       "Rename",
    file_rename_placeholder: "New name",
    file_rename_btn:         "Rename",

    review_changes:          "Changes",
    review_staged:           "Staged",
    review_unstaged:         "Unstaged",
    review_untracked:        "Untracked",
    review_conflicts:        "Conflicts",
    review_conflict_label:   "conflict",
    review_resolved:              "Resolved",
    review_resolved_label:        "resolved",
    review_pending_stash_merge:   "After committing, your local changes will be re-applied and may require another merge.",
    review_accept_mine:      "Accept mine",
    review_accept_theirs:    "Accept theirs",
    review_accept_both:      "Accept both",
    review_accept_committed: "Accept committed",
    review_accept_stash:     "Accept stash",
    review_save:             "Save",
    review_edit:             "Edit",
    review_done_editing:     "Done editing",
    review_ctx_stage:        "Stage",
    review_ctx_unstage:      "Unstage",
    review_ctx_revert:       "Revert",
    review_untracked_short:  "U",
    review_no_changes:       "No changes",
    review_no_commits:       "No commits yet",
    review_detached_head:    "Detached HEAD",
    review_select_file:      "Select a file to view diff",
    review_no_changes_for_file: "No changes for {path}",
    review_no_git:           "No git repository",
    review_no_git_desc:      "The project \"{name}\" is not inside a git repository.",
    review_no_git_desc_generic: "This project is not inside a git repository.",
    review_init_git:         "Initialize git repository",
    review_initializing:     "Initializing...",
    review_agent_offline:    "Agent offline",
    review_agent_offline_desc: "The agent is not connected. Start the agent process to enable git features.",
    review_error:            "Failed to load git data",
    review_dismiss_error:    "Dismiss",
    review_merge_required:   "Merge required",
    review_merge_required_desc: "This pull needs a merge (branches diverged or you have uncommitted changes). Nothing was changed. Start a merge to reconcile.",
    review_start_merge:      "Start merge",
    review_merging:          "Merging...",
    review_identity_required: "Git identity required",
    review_identity_required_desc: "Set a name and email to author the merge commit.",
    review_identity_name:    "Name",
    review_identity_email:   "Email",
    review_save_identity:    "Save & merge",
    review_saving_identity:  "Saving...",
    review_retry:            "Retry",
    review_actions_btn:      "Actions",
    review_action_refresh:   "Refresh",
    review_action_push:      "Push",
    review_action_pull:      "Pull",
    review_action_reset:     "Reset",
    review_reset_title:      "Reset Changes",
    review_reset_confirm:    "Discard all uncommitted changes? This cannot be undone.",
    review_reset_btn:        "Reset",
    review_no_branch:        "no branch",
    review_new_branch_btn:   "+",
    review_new_branch_dialog_title: "Create New Branch",
    review_new_branch_placeholder: "Branch name",
    review_new_branch_option:       "New branch",
    review_create_branch:    "Create",
    review_creating_branch:  "Creating...",
    review_vault:                   "Vault",
    vault_configure_banner:         "Configure vault",
    vault_configure_modal_title:    "Configure Vault",
    vault_add_new:                  "Add vault",
    vault_unnamed:                  "Unnamed",
    vault_name_label:               "Name",
    vault_engine_label:             "Engine",
    vault_engine_local_folder:      "Local folder",
    review_branch_search_placeholder: "Search branches...",
    review_branch_no_results:       "No results",
    review_commits_ahead:           "Commits ahead of remote",
    review_commits_behind:          "Commits behind remote",
    review_switch_branch_title:             "Switch Branch",
    review_switch_branch_switch_btn:        "Switch to",
    review_switch_branch_checkout_current_btn: "Checkout current",
    review_commit_placeholder: "Commit message",
    review_commit_btn:       "Commit",
    review_commit_merge_btn: "Commit merge",
    review_merge_in_progress: "Merge in progress — commit to complete it.",
    review_merge_in_progress_banner: "Merge in progress — resolve conflicts and commit, or abort to restore your previous state.",
    code_merge_in_progress: "Merge in progress — resolve conflicts and commit",
    review_abort_merge:       "Abort",
    review_aborting:         "Aborting...",
    review_committing:       "Committing...",

    review_remove_file_title:   "Revert changes",
    review_remove_file_confirm: "Revert changes to \"{path}\"? This cannot be undone.",
    review_remove_file_btn:     "Revert",

    review_revert_all:          "Revert all",
    review_revert_all_title:    "Revert all changes",
    review_revert_all_confirm:  "Discard all uncommitted changes? This cannot be undone.",
    review_revert_all_btn:      "Revert all",

    review_checkout_conflict_title: "Checkout Conflict",
    review_checkout_conflict_desc:  "Local changes would be overwritten when switching to \"{branch}\". Stash your changes to save them before switching.",
    review_stash_placeholder:       "Stash name (optional)",
    review_stash_and_switch:        "Stash & Switch",
    review_stashing:                "Stashing...",

    tabs_close_tab:                 "Close tab",
    tabs_close_other_tabs:          "Close other tabs",
    tabs_close_all_tabs:            "Close all tabs",

    ssh_keys_empty:                 "No SSH keys yet.",
    ssh_keys_name_label:            "Name",
    ssh_keys_name_placeholder:      "e.g. deploy key",
    ssh_keys_private_label:         "Private key",
    ssh_keys_private_placeholder:   "-----BEGIN OPENSSH PRIVATE KEY-----",
    ssh_keys_public_label:          "Public key (optional)",
    ssh_keys_public_placeholder:    "ssh-ed25519 AAAA...",
    ssh_keys_upload:                "Upload file",
    ssh_keys_enter_manually:        "Enter manually",
    ssh_keys_add:                   "Add key",
    ssh_keys_add_new:               "Add new key",
    ssh_keys_new_title:             "New SSH key",
    ssh_keys_cancel:                "Cancel",
    ssh_keys_use:                   "Use",
    ssh_keys_active:                "Active",
    ssh_keys_remove:                "Remove",
    ssh_keys_remove_title:          "Remove SSH key",
    ssh_keys_remove_confirm:        "Remove \"{name}\"? This cannot be undone.",
} as const;
